/**
 * BASKETS & THINGS — theme.js
 * General theme interactions, mobile menu, newsletter, product page
 */
(function () {
  'use strict';

  // ── Mobile Nav ──────────────────────────────────────────────
  const mobileBtn  = document.querySelector('.mobile-menu-btn');
  const siteNav    = document.querySelector('.site-nav');

  if (mobileBtn && siteNav) {
    mobileBtn.addEventListener('click', () => {
      const open = siteNav.style.display === 'flex';
      siteNav.style.display  = open ? 'none' : 'flex';
      siteNav.style.flexDirection = 'column';
      siteNav.style.position = 'absolute';
      siteNav.style.top      = '72px';
      siteNav.style.left     = '0';
      siteNav.style.right    = '0';
      siteNav.style.background = 'var(--bt-cream)';
      siteNav.style.padding  = '16px 24px';
      siteNav.style.boxShadow = '0 8px 32px rgba(74,29,140,0.15)';
      siteNav.style.zIndex   = '699';
    });
  }

  // ── Newsletter ─────────────────────────────────────────────
  const nlForm = document.querySelector('.newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', e => {
      e.preventDefault();
      const input = nlForm.querySelector('input[type="email"]');
      if (!input || !input.value.includes('@')) {
        window.btShowToast && window.btShowToast('Please enter a valid email!');
        return;
      }
      // Shopify newsletter form submission (uses native Shopify customers/newsletter endpoint)
      input.value = '';
      window.btShowToast && window.btShowToast('🎉 Welcome to the Sweet Life!');
    });
  }

  // ── Product Page Variants ──────────────────────────────────
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.dataset.group;
      document.querySelectorAll(`.variant-btn[data-group="${group}"]`).forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      // Update price display
      const price = btn.dataset.price;
      const priceEl = document.querySelector('.product-detail__price');
      if (priceEl && price) {
        priceEl.textContent = `$${parseFloat(price).toFixed(2)}`;
      }
    });
  });

  // ── Tab switcher (product page / collection) ───────────────
  document.addEventListener('click', e => {
    const tab = e.target.closest('.tab-btn');
    if (!tab) return;
    const container = tab.closest('.product-tabs') || tab.closest('[data-tabs]');
    if (!container) return;

    container.querySelectorAll('.tab-btn').forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');

    const target = tab.dataset.tab;
    const grid = document.querySelector('#bt-product-grid');
    if (!grid) return;

    grid.querySelectorAll('[data-category]').forEach(card => {
      if (target === 'all' || card.dataset.category === target) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  });

  // ── Add to cart (standard products) ───────────────────────
  document.addEventListener('click', e => {
    const atcBtn = e.target.closest('[data-add-to-cart]');
    if (!atcBtn) return;

    const form = atcBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    if (form && window.Shopify) {
      // Submit via AJAX
      const fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(r => r.json())
        .then(() => {
          window.btShowToast && window.btShowToast('🛒 Added to cart!');
          atcBtn.textContent = '✅ Added!';
          setTimeout(() => { atcBtn.textContent = 'Add to Cart'; }, 1800);
          // Update cart count via Shopify cart API
          return fetch('/cart.js');
        })
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('.bt-cart-count').forEach(el => { el.textContent = cart.item_count; });
        })
        .catch(() => form.submit());
    }
  });

  // ── Smooth scroll for internal anchors ────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // ── Drink "Order Now" ─────────────────────────────────────
  document.addEventListener('click', e => {
    const drinkBtn = e.target.closest('[data-drink-order]');
    if (!drinkBtn) return;
    const name  = drinkBtn.dataset.drinkName  || 'Party Punch';
    const price = drinkBtn.dataset.drinkPrice || '85';
    window.btShowToast && window.btShowToast(`🍹 ${name} added! Check DMs to confirm.`);
  });

})();
